import { useState } from 'react';

import HeaderUserIcon from '@/assets/svg/ui-elements/user-outline.svg';
import { PagePaths } from '@/routes/page-paths';
import { GlobalHeader } from '@/shared/design-system';
import { useUserAccount } from '@/shared/design-system/components/UserDropdown/use-user-account';

import { HeaderActions } from '../header-actions';
import { WalletChip } from '../wallet-chip';
import { MobileUserButton } from './MobileHeader.styled';
import { NavDrawer } from './nav-drawer';
import { UserAccountDrawer } from './user-account-drawer';

export const MobileHeader = () => {
  const userAccount = useUserAccount();
  const { open: accountOpen, setOpen: setAccountOpen, headshotFile } = userAccount;

  const [navOpen, setNavOpen] = useState(false);

  return (
    <>
      <GlobalHeader
        viewport="mobile"
        logoHref={PagePaths.allFunds}
        userDropdown={
          <MobileUserButton
            type="button"
            aria-label="Open account"
            onClick={() => setAccountOpen(true)}
          >
            {headshotFile?.url ? (
              <img src={headshotFile.url} alt={headshotFile.fileName} />
            ) : (
              <HeaderUserIcon aria-hidden="true" />
            )}
          </MobileUserButton>
        }
        wallet={<WalletChip />}
        actions={<HeaderActions />}
        onMenuClick={() => setNavOpen(true)}
      />

      <UserAccountDrawer open={accountOpen} onOpenChange={setAccountOpen} data={userAccount} />

      <NavDrawer
        open={navOpen}
        onOpenChange={setNavOpen}
        onUserAccountOpen={() => setAccountOpen(true)}
        userAccount={userAccount}
      />
    </>
  );
};
